import React, { Component } from 'react'
import _ from 'lodash'
import Header from './screens/header/Header'
import Footer from './screens/footer/Footer'
import MobileHeader from './screens/header/MobileHeader'
import MobileListView from './screens/MobileListView'
import Upload from './screens/Upload'
import Share from './screens/Share'
import { apiConstants } from './constants/apiConstants'
import {
  isUserHasAccess,
  removeExtraSlashes,
  isCorpOrGoPayUser,
} from './helper'
import AccessDenied from './screens/AccessDenied'
import HelpPage from './screens/HelpPage'
import { logoutUser } from './api/request'
import { constants } from './constants/constants'
import { Message } from '@paypalcorp/worldready-react'
import PermissionRequestHome from './screens/PermissionRequest/PermissionRequestHome'
import { sharePermissionConstants } from './constants/sharePermissionConstants'

class App extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      showUpload: false,
      showShare: false,
      itemToShare: {},
      activeMenu: 'home',
      appStateInprogress: false,
      isUserLoggedout: false,
    }
  }

  componentDidMount = () => {
    const { user } = this.props
    if (window.PAYPAL && window.PAYPAL.analytics) {
      const options = {
        data: {
          pgrp: `dropzone:${this.props.user.accType}`,
          page: `dropzone:search:${this.props.user.accType}`,
          comp: 'filevaultnodeweb',
          link: `search`,
        },
      }
      if (isCorpOrGoPayUser(user)) {
        options.data.internal_user = user.username
      }
      window.PAYPAL.analytics.setup(options)
    }
    window.onpopstate = this.onBrowserBackAndForwardButtonEvent
    document.addEventListener('keydown', this.handleKeydown, false)
  }

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.handleKeydown, false)
  }

  handleKeydown = (event) => {
    const { keyCode } = event
    const { showShare, showUpload } = this.state
    if (keyCode === 27) {
      if (showShare) {
        this.setState({ showShare: false })
      }

      if (showUpload) {
        this.setState({ showUpload: false })
      }
    }
  }

  onBrowserBackAndForwardButtonEvent = (e) => {
    e.preventDefault()
    const path = removeExtraSlashes(
      this.props.location.pathname.replace(apiConstants.URLPrefix, ''),
    )
    this.props.actions.setBaseFolder(path === '' ? '/' : path)
  }

  setRef = (ref) => {
    this.parentViewRef = ref
  }

  setUploadFileBoxVisibility = (showUpload) => {
    this.setState({ showUpload })
  }

  setShareBoxVisibility = (showShare, itemToShare) => {
    this.setState({ showShare, itemToShare })
  }

  handleRequestAccessClick = () => {
    this.setShareBoxVisibility(false, {})
    this.props.history.push(
      `${apiConstants.URLPrefix}${apiConstants.SharePermissionRequest}`,
      { showPermissionBox: true },
    )
  }

  setErrorMessage = (err, isMsgToBeUpdated = true) => {
    this.parentViewRef.setErrorMessage(err, isMsgToBeUpdated)
  }

  setActiveMenu = (activeMenu) => {
    this.setState({ activeMenu })
    this.props.actions.setActiveMenu(activeMenu)
  }

  setActiveMenuFromPath = (menu) => {
    this.props.actions.setActiveMenu(menu)
    return menu
  }

  updateLogoutInprogress = (appStateInprogress) => {
    this.setState({ appStateInprogress })
  }

  updateFileOrFolderSharedStatus = () => {
    const { itemToShare } = this.state
    const { selectedFolderToSearch } = this.props
    this.setState({ itemToShare: { ...itemToShare, isShared: 'true' } })
    this.props.actions.setSelectedFolderToSearch({
      ...selectedFolderToSearch,
      isShared: 'true',
    })
  }

  logoutUser = async () => {
    const { user } = this.props
    this.updateLogoutInprogress(true)

    const logoutResponse = await logoutUser()
    if (logoutResponse && logoutResponse.status === 200) {
      this.updateLogoutInprogress(false)
      this.setState({ isUserLoggedout: true })
      if (isCorpOrGoPayUser(user)) {
        this.props.actions.setUser({})
      } else {
        this.navigateUserAfterLogout(false)
      }
    } else {
      this.updateLogoutInprogress(false)
      this.parentViewRef.setErrorMessage(logoutResponse, true)
    }
  }

  navigateUserAfterLogout = (isCorp) => {
    const path = removeExtraSlashes(
      this.props.location.pathname.replace(apiConstants.URLPrefix, ''),
    )
    if (isCorp) {
      window.location.href = `${apiConstants.URLPrefix}`
    } else {
      window.location.href = `${this.props.ulSignin}/${path}`
    }
  }

  // --- helpers ---

  /**
   * Extracts the requestId from a pathname if it follows:
   *   <shareBase>/<requestId>[/]
   * Returns null if not present or path doesn't match shareBase.
   */

  escapeRegExp = (str) => {
    return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  extractRequestId = (pathname) => {
    const match = pathname.match(sharePermissionConstants.RequestIdFormat)
    return match ? match[1] : null
  }

  getRoleToRequest = (isCOC) => {
    return isCOC ? constants.IAMRole.cocUser : constants.IAMRole.user
  }

  calculatePageToRender = () => {
    const { location = {}, user } = this.props || {}
    const rawPathname = location.pathname || ''
    const pathname = removeExtraSlashes(rawPathname)

    const urlPrefix = apiConstants.URLPrefix || ''
    const helpPath = removeExtraSlashes(`${urlPrefix}${apiConstants.Help}`)
    const shareAccessRequest = removeExtraSlashes(
      `${urlPrefix}${apiConstants.SharePermissionRequest}`,
    )

    // Strictly match a requestId only when the path starts with the shareBase
    const requestId = this.extractRequestId(pathname)

    if (pathname === helpPath) {
      return <HelpPage {...this.props} />
    }

    if (
      pathname === shareAccessRequest &&
      user.accType === constants.CorpUser
    ) {
      return <PermissionRequestHome {...this.props} />
    }

    if (requestId && user.accType === constants.CorpUser) {
      return <PermissionRequestHome {...this.props} requestId={requestId} />
    }

    return (
      <MobileListView
        ref={this.setRef}
        {...this.props}
        setUploadFileBoxVisibility={this.setUploadFileBoxVisibility}
        setShareBoxVisibility={this.setShareBoxVisibility}
        setSharePermissionBoxVisibility={this.setSharePermissionBoxVisibility}
      />
    )
  }

  renderLoading = () => {
    return (
      <div className="app__loading">
        <div className="app__logout-container">
          <div className="app__logout-title">
            <Message id="message.logout.wait.info" />
          </div>
          <p className="ppvx_loading-spinner" role="alert">
            <span className="ppvx_loading-spinner__screenreader" />
          </p>
        </div>
      </div>
    )
  }

  renderLogoutInfo = () => {
    const { user } = this.props
    return (
      <div id="logout_user" className="ppvx_text--md flexCenter app__logout">
        <div>
          <Message id="message.logout.success" />
        </div>
        <div>
          <Message
            id="message.login.back"
            link={(innerMessage) => (
              <a
                className="app__login-again"
                data-pa-pgrp={`dropzone:${user.accType}`}
                data-pa-page={`dropzone:login:${user.accType}`}
                data-pa-click="login"
                onClick={() => this.navigateUserAfterLogout(true)}
              >
                {innerMessage}
              </a>
            )}
          />
        </div>
      </div>
    )
  }

  switchAppAndLogoutRender = (isUserLoggedout) => {
    return isUserLoggedout ? this.renderLogoutInfo() : this.renderApp()
  }

  renderApp = () => {
    const { user, deployEnv } = this.props
    const { hasAccess, isCOC } = isUserHasAccess(
      user,
      constants.Users.user,
      deployEnv,
    )

    return (
      <div
        className="contents vx_mainContent"
        id="contents"
        role="main"
        aria-labelledby="heading1"
      >
        <MobileHeader />
        {hasAccess ? (
          this.calculatePageToRender()
        ) : (
          <AccessDenied
            user={user}
            roleToRequest={this.getRoleToRequest(isCOC)}
            isCOC={isCOC}
          />
        )}
      </div>
    )
  }

  render() {
    const { activeMenu, appStateInprogress, isUserLoggedout } = this.state
    return (
      <div className="app-container" data-testid="home-page">
        <input
          type="checkbox"
          id="toggleNavigation"
          className="vx_globalNav-toggleCheckbox"
        />
        <Header
          {...this.props}
          activeMenu={activeMenu}
          setActiveMenu={this.setActiveMenu}
          setActiveMenuFromPath={this.setActiveMenuFromPath}
          updateLogoutInprogress={this.updateLogoutInprogress}
          logoutUser={this.logoutUser}
          isUserLoggedout={isUserLoggedout}
        />
        <div id="js_foreground" className="vx_foreground-container">
          {this.switchAppAndLogoutRender(isUserLoggedout)}
          <label
            className="vx_globalNav-toggleTrigger_overlay"
            htmlFor="toggleNavigation"
          />
          <Footer
            {...this.props}
            isUserLoggedout={isUserLoggedout}
            setActiveMenu={this.setActiveMenu}
          />
        </div>
        {this.state.showUpload && (
          <Upload
            {...this.props}
            showUpload={this.state.showUpload}
            setUploadFileBoxVisibility={this.setUploadFileBoxVisibility}
            setErrorMessage={this.parentViewRef.setErrorMessage}
            onUploadFailure={this.parentViewRef.onUploadFailure}
            validateFileBeforeUpload={
              this.parentViewRef.validateFileBeforeUpload
            }
            validateSelectedFilesToUpload={
              this.parentViewRef.validateSelectedFilesToUpload
            }
          />
        )}
        {this.state.showShare && (
          <Share
            {...this.props}
            setShareBoxVisibility={this.setShareBoxVisibility}
            showShare={this.state.showShare}
            itemToShare={this.state.itemToShare}
            constructErrorMessage={this.parentViewRef.setErrorMessage}
            updateFileOrFolderSharedStatus={this.updateFileOrFolderSharedStatus}
            handleRequestAccessClick={this.handleRequestAccessClick}
          />
        )}
        {appStateInprogress ? this.renderLoading() : ''}
      </div>
    )
  }
}

export default App
